// Sticky Header
class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
  
    /**
     * Calls when Component is Initialized in DOM
     *
     */
    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
  
      this.onScrollHandler = this.onScroll.bind(this);
  
      window.addEventListener('scroll', this.onScrollHandler, false);
  
      this.createObserver();
    }
  
    /**
     * Calls when Component is removed from DOM
     *
     */
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  
    /**
     * To observe Sticky header visibility on User Scroll
     *
     */
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
  
      observer.observe(this.header);
    }
  
    /**
     * Window Scroll event
     *
     */
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
  
      this.currentScrollTop = scrollTop;
    }
  
    /**
     * Hide Sticky header
     * Close Menu Drawer / Seach Modal / Cart Drawer
     *
     */
    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.closeSearchModal();
      this.closeMenuDropdowns();
    }
  
    /**
     * Show Sticky Header
     *
     */
    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      // this.header.classList.remove('shopify-section-header-hidden');
    }
  
    reset() {
      this.header.classList.remove('shopify-section-header-sticky', 'animate');
    }
  
    /**
     * Close Search Modal on Window Scroll
     *
     */
    closeSearchModal() {
      this.searchModal = this.searchModal || document.querySelector('search-modal');
      if(!this.searchModal) return;
      this.searchModal.close(false);
    }
  
    /**
     * Close Menu Dropdowns
     *
     */
    closeMenuDropdowns() {
      let openDropdowns = Array.from(document.querySelectorAll('.dropdown.open'));
      openDropdowns.forEach((ele) => {
        ele.classList.remove('open');
      });
    }
  }
  customElements.define('sticky-header', StickyHeader);

 class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.formSearch = this.querySelector('.search-details form[role="search"]')
    this.inputSearch = this.querySelector('.search-details input[type="search"]');
    this.result = document.createElement('div');
    this.result.classList.add('result-container');
    this.formSearch.insertAdjacentElement('afterend', this.result);
    this.defaultContainer = this.querySelector('.search-details .quick-search-products-wrapper')
    this.defaultContainer.hidden = false;
    this.result.hidden = true;
    this.backdropOpen = this.querySelector('.search-backdrop');
    this.iconClose = this.querySelector('.icon-close');
    this.iconSearch = this.querySelector('.icon-search');
    this.details = this.querySelector('.search-details');
    
    
    this.inputSearch.addEventListener('input', this.onInputChanged.bind(this));
    this.iconClose.addEventListener('click', this.onClose.bind(this));
    this.iconSearch.addEventListener('click', this.onOpen.bind(this));
    this.backdropOpen.addEventListener('click', this.onCloseBackdrop.bind(this));
  };

  onOpen() {
    this.backdropOpen.classList.add('backdrop-activated');
    const body = document.querySelector('body');
    body.classList.add('scroll-fixed');
  }

  onInputChanged() {
    const query = encodeURIComponent(this.inputSearch.value.trim());


    if (query === '') {
      this.onReset();
      return;
    }

    fetch(window.Shopify.routes.root + `search/suggest?q=${query}&section_id=predictive-search&resources[type]=product,query&resources[limit]=5&resources[options][fields]=title,product_type,variants.sku`)
      .then((response) => response.text())
      .then((data) => {
        const resultsMarkup = new DOMParser().parseFromString(data, 'text/html');
        const section = resultsMarkup.querySelector('.predictive-search-results');
       

        if (section && section.innerHTML.trim() !== '') {
          this.result.innerHTML = section.innerHTML;
          this.result.hidden = false;
          this.defaultContainer.hidden = true;
        } else {
          this.onReset();
         
         
          
        }

      })
      .catch((error) => {
        console.error(error);

      });
  };
  onReset() {

    this.result.hidden = true;
    this.defaultContainer.hidden = false;
    this.backdropOpen.classList.remove('backdrop-activated');
  
  }

  onClose() {
     this.backdropOpen.classList.remove('backdrop-activated');
    const body = document.querySelector('body');
    body.classList.remove('scroll-fixed');
  }
  
  onCloseBackdrop() {
    this.onClose();
    this.details.removeAttribute('open');
  }
};
customElements.define('predictive-search', PredictiveSearch)